import { render, staticRenderFns } from "./practice.vue?vue&type=template&id=a2fd2ee2&scoped=true"
import script from "./practice.vue?vue&type=script&lang=js"
export * from "./practice.vue?vue&type=script&lang=js"
import style0 from "./practice.vue?vue&type=style&index=0&id=a2fd2ee2&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a2fd2ee2",
  null
  
)

export default component.exports